import { Modal } from "@mantine/core";
import { PortalAccessGrant } from "../../../services/admin/portalAccess.service";
import { EditPortalGrantForm } from "./EditPortalGrantForm";

interface EditPortalGrantModalProps {
  opened: boolean;
  onClose: () => void;
  grant: PortalAccessGrant | null;
}

export function EditPortalGrantModal({
  opened,
  onClose,
  grant,
}: EditPortalGrantModalProps) {
  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      closeOnClickOutside={false}
      size="md"
      centered
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Edit Portal Access</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        {grant && (
          <EditPortalGrantForm key={grant.id} grant={grant} onClose={onClose} />
        )}
      </Modal.Content>
    </Modal.Root>
  );
}
